<template>
    <v-container fluid class="pa-4">

        <v-card class="mb-4">
            <v-card-title class="d-flex justify-space-between align-center">
                <div class="d-flex align-center ga-3">
                    <span class="title">{{ $t('title.popisPregled') }} -</span>
                    <template v-if="popisInfo">
                        <span style="font-size:14px; color:#555;"> {{ popisInfo.Name }}</span>
                        <v-chip :color="popisInfo.Status === false ? 'success' : 'error'" variant="tonal" size="small">
                            {{ popisInfo.Status === false ? $t('general.otvoren') : $t('general.zatvoren') }}
                        </v-chip>
                    </template>
                </div>
                <v-btn size="small" variant="outlined" color="secondary" class="action-btn" icon="mdi-arrow-left"
                    @click="$router.back()" />
            </v-card-title>
        </v-card>

        <!-- DIALOG ZA AKCIJU (+ ili -) -->
        <BaseModal v-model="actionDialog"
            :title="pendingActionType === 'check' ? $t('general.skenirajUPPER') : $t('general.nijePronadjenoUPPER')">
            <div class="mb-3" style="font-size: 14px; color: rgba(0,0,0,0.6);">
                <strong>{{ pendingItem?.InvNumber }}</strong> — {{ pendingItem?.Name }}
            </div>

            <div v-if="pendingActionType === 'notfound'" style="font-size: 14px; color: rgba(0,0,0,0.7);">
                {{ actionNote }}
            </div>

            <v-textarea v-else v-model="actionNote" rows="3" density="compact" variant="outlined">
                <template #label>
                    <span style="font-size: 14px;">{{ $t('general.napomena') }}</span>
                </template>
            </v-textarea>

            <template #footer>
                <div class="d-flex justify-end ga-2">
                    <v-btn variant="outlined" @click="closeActionDialog">
                        <span style="font-size:14px; font-weight:600;">{{ $t('general.cancel') }}</span>
                    </v-btn>
                    <v-btn :color="pendingActionType === 'check' ? 'primary' : 'error'" variant="flat"
                        @click="confirmAction" :loading="actionLoading">
                        <span style="font-size:14px; font-weight:600; color:#FFF">{{ $t('general.potvrdi') }}</span>
                    </v-btn>
                </div>
            </template>


        </BaseModal>

        <v-row>
            <!-- LIJEVA KARTICA — TABOVI -->
            <v-col cols="12" md="6">
                <v-card height="100%">
                    <v-card-title class="d-flex justify-space-between align-center">
                        <v-tabs v-model="activeTab" density="compact" color="primary"
                            style="border-bottom: 1px solid rgba(0,0,0,0.08);">
                            <v-tab value="popisana"
                                style="font-size:14px; font-weight:600; text-transform:none; letter-spacing:0;">
                                {{ $t('table.popis.skeniranaSredstva') }}
                                <v-chip size="x-small" color="success" variant="tonal" class="ml-2">
                                    {{ skenirano.length }}
                                </v-chip>
                            </v-tab>
                            <v-tab value="nijePronadjena"
                                style="font-size:14px; font-weight:600; text-transform:none; letter-spacing:0;">
                                {{ $t('table.popis.nijePronadjena') }}
                                <v-chip size="x-small" color="warning" variant="tonal" class="ml-2">
                                    {{ nijePronasao.length }}
                                </v-chip>
                            </v-tab>
                        </v-tabs>
                        <v-text-field v-model="searchSkenirano" prepend-inner-icon="mdi-magnify" density="compact"
                            hide-details autocomplete="off" class="ml-5" />
                    </v-card-title>

                    <v-divider />

                    <v-card-text>
                        <v-window v-model="activeTab">

                            <!-- TAB 1 — Popisana sredstva -->
                            <v-window-item value="popisana">
                                <v-data-table :headers="headers" :items="filteredSkenirano" :loading="loading"
                                    :loading-text="$t('general.loading')" class="custom-header" :items-per-page="15"
                                    density="compact">
                                    <template v-slot:headers="{ columns, toggleSort, isSorted, getSortIcon }">
                                        <tr>
                                            <th v-for="column in columns" :key="column.key"
                                                @click="() => column.sortable && toggleSort(column)" :style="{
                                                    cursor: column.sortable ? 'pointer' : 'default',
                                                    width: column.width
                                                }" class="sortable-header">
                                                <div class="d-flex align-center justify-space-between">
                                                    <strong>{{ column.title }}</strong>
                                                    <v-icon v-if="column.sortable" size="12" class="sort-icon ml-2"
                                                        :class="{ active: isSorted(column) }">
                                                        {{ isSorted(column) ? getSortIcon(column) : 'mdi-arrow-up-down'
                                                        }}
                                                    </v-icon>
                                                </div>
                                            </th>
                                        </tr>
                                    </template>
                                    <template v-slot:[`item.InvNumber`]="{ item }">{{ item.InvNumber }}</template>
                                    <template v-slot:[`item.Name`]="{ item }">{{ item.Name }}</template>
                                    <template v-slot:[`item.UserName`]="{ item }">{{ item.UserName || '-' }}</template>
                                    <template v-slot:[`item.LocationName`]="{ item }">{{ item.LocationName || '-'
                                        }}</template>
                                    <template v-slot:[`item.RoomName`]="{ item }">{{ item.RoomName || '-' }}</template>
                                    <template v-slot:[`item.Actions`]="{ item }">
                                        <div class="d-flex justify-center">
                                            <v-tooltip location="bottom" content-class="custom-tooltip"
                                                :text="$t('general.vrati')">
                                                <template #activator="{ props }">
                                                    <v-btn v-bind="props" size="small" variant="outlined"
                                                        color="warning" class="action-btn"
                                                        @click.stop="returnChecked(item)">
                                                        <v-icon size="16">mdi-arrow-right</v-icon>
                                                    </v-btn>
                                                </template>
                                            </v-tooltip>
                                        </div>
                                    </template>
                                </v-data-table>
                            </v-window-item>

                            <!-- TAB 2 — Sredstva koja nisu pronađena -->
                            <v-window-item value="nijePronadjena">
                                <v-data-table :headers="headers" :items="filteredNijePronasao" :loading="loading"
                                    :loading-text="$t('general.loading')" class="custom-header" :items-per-page="15"
                                    density="compact">
                                    <template v-slot:headers="{ columns, toggleSort, isSorted, getSortIcon }">
                                        <tr>
                                            <th v-for="column in columns" :key="column.key"
                                                @click="() => column.sortable && toggleSort(column)" :style="{
                                                    cursor: column.sortable ? 'pointer' : 'default',
                                                    width: column.width
                                                }" class="sortable-header">
                                                <div class="d-flex align-center justify-space-between">
                                                    <strong>{{ column.title }}</strong>
                                                    <v-icon v-if="column.sortable" size="12" class="sort-icon ml-2"
                                                        :class="{ active: isSorted(column) }">
                                                        {{ isSorted(column) ? getSortIcon(column) : 'mdi-arrow-up-down'
                                                        }}
                                                    </v-icon>
                                                </div>
                                            </th>
                                        </tr>
                                    </template>
                                    <template v-slot:[`item.InvNumber`]="{ item }">{{ item.InvNumber }}</template>
                                    <template v-slot:[`item.Name`]="{ item }">{{ item.Name }}</template>
                                    <template v-slot:[`item.UserName`]="{ item }">{{ item.UserName || '-' }}</template>
                                    <template v-slot:[`item.LocationName`]="{ item }">{{ item.LocationName || '-'
                                        }}</template>
                                    <template v-slot:[`item.RoomName`]="{ item }">{{ item.RoomName || '-' }}</template>
                                    <template v-slot:[`item.Actions`]="{ item }">
                                        <div class="d-flex justify-center">
                                            <v-tooltip location="bottom" content-class="custom-tooltip"
                                                :text="$t('general.vrati')">
                                                <template #activator="{ props }">
                                                    <v-btn v-bind="props" size="small" variant="outlined"
                                                        color="warning" class="action-btn"
                                                        @click.stop="returnNotFound(item)">
                                                        <v-icon size="16">mdi-arrow-right</v-icon>
                                                    </v-btn>
                                                </template>
                                            </v-tooltip>
                                        </div>
                                    </template>
                                </v-data-table>
                            </v-window-item>

                        </v-window>
                    </v-card-text>
                </v-card>
            </v-col>

            <!-- DESNA TABELA — PREOSTALA SREDSTVA -->
            <v-col cols="12" md="6">
                <v-card height="100%">
                    <v-card-title class="d-flex justify-space-between align-center">
                        <v-tabs density="compact" color="primary" style="border-bottom: 1px solid rgba(0,0,0,0.08);">
                            <v-tab value="preostala"
                                style="font-size:14px; font-weight:600; text-transform:none; letter-spacing:0;">
                                {{ $t('table.popis.preostalaSredstva') }}
                                <v-chip size="x-small" color="error" variant="tonal" class="ml-2">
                                    {{ preostala.length }}
                                </v-chip>
                            </v-tab>
                        </v-tabs>
                        <v-text-field v-model="searchPreostala" prepend-inner-icon="mdi-magnify" density="compact"
                            hide-details autocomplete="off" class="ml-5" />
                    </v-card-title>

                    <v-divider />

                    <v-card-text>
                        <v-data-table :headers="headersPreostala" :items="filteredPreostala" :loading="loading"
                            :loading-text="$t('general.loading')" class="custom-header" :items-per-page="15"
                            density="compact">

                            <template v-slot:headers="{ columns, toggleSort, isSorted, getSortIcon }">
                                <tr>
                                    <th v-for="column in columns" :key="column.key"
                                        @click="() => column.sortable && toggleSort(column)" :style="{
                                            cursor: column.sortable ? 'pointer' : 'default',
                                            width: column.width
                                        }" class="sortable-header">
                                        <div class="d-flex align-center justify-space-between">
                                            <strong>{{ column.title }}</strong>
                                            <v-icon v-if="column.sortable" size="12" class="sort-icon ml-2"
                                                :class="{ active: isSorted(column) }">
                                                {{ isSorted(column) ? getSortIcon(column) : 'mdi-arrow-up-down' }}
                                            </v-icon>
                                        </div>
                                    </th>
                                </tr>
                            </template>

                            <template v-slot:[`item.InvNumber`]="{ item }">{{ item.InvNumber }}</template>
                            <template v-slot:[`item.Name`]="{ item }">{{ item.Name }}</template>
                            <template v-slot:[`item.UserName`]="{ item }">{{ item.UserName || '-' }}</template>
                            <template v-slot:[`item.LocationName`]="{ item }">{{ item.LocationName || '-' }}</template>
                            <template v-slot:[`item.RoomName`]="{ item }">{{ item.RoomName || '-' }}</template>

                            <template v-slot:[`item.Actions`]="{ item }">
                                <div class="d-flex justify-center">
                                    <v-tooltip location="bottom" content-class="custom-tooltip">
                                        <template #activator="{ props }">
                                            <v-btn v-bind="props" size="small" variant="outlined" color="success"
                                                class="action-btn mr-2" @click.stop="openActionDialog(item, 'check')">
                                                <v-icon size="16">mdi-plus</v-icon>
                                            </v-btn>
                                        </template>
                                        {{ $t('general.skeniraj') }}
                                    </v-tooltip>

                                    <v-tooltip location="bottom" content-class="custom-tooltip"
                                        :text="$t('general.nijePronadjeno')">
                                        <template #activator="{ props }">
                                            <v-btn v-bind="props" size="small" variant="outlined" color="error"
                                                class="action-btn" @click.stop="openActionDialog(item, 'notfound')">
                                                <v-icon size="16">mdi-minus</v-icon>
                                            </v-btn>
                                        </template>
                                    </v-tooltip>
                                </div>
                            </template>

                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

    </v-container>
</template>

<script>
import BaseModal from '@/components/dialogs/BaseModal.vue'
export default {
    name: 'PopisPreviewPage',
    components: { BaseModal },
    data() {
        return {
            loading: false,
            skenirano: [],
            preostala: [],
            nijePronasao: [],
            activeTab: 'popisana',
            searchSkenirano: '',
            searchPreostala: '',
            actionDialog: false,
            actionLoading: false,
            actionNote: '',
            pendingItem: null,
            popisInfo: null,

            pendingActionType: null,
            deleteNote: '',

            statusChangeNote: '',
            pendingStatus: null,
            statusNoteDialog: false,

            headers: [
                { title: this.$t('table.asset.InvBr'), key: 'InvNumber', sortable: true, width: '12%' },
                { title: this.$t('table.asset.naziv'), key: 'Name', sortable: true, width: '25%' },
                { title: this.$t('table.asset.zaduzenaOsoba'), key: 'UserName', sortable: true, width: '18%' },
                { title: this.$t('table.assetFull.Lokacija'), key: 'LocationName', sortable: true, width: '18%' },
                { title: this.$t('table.assetFull.Soba'), key: 'RoomName', sortable: true, width: '17%' },
                { title: this.$t('general.optionsUPPER'), key: 'Actions', sortable: false, width: '10%' },
            ],
            headersPreostala: [
                { title: this.$t('table.asset.InvBr'), key: 'InvNumber', sortable: true, width: '12%' },
                { title: this.$t('table.asset.naziv'), key: 'Name', sortable: true, width: '22%' },
                { title: this.$t('table.asset.zaduzenaOsoba'), key: 'UserName', sortable: true, width: '16%' },
                { title: this.$t('table.assetFull.Lokacija'), key: 'LocationName', sortable: true, width: '20%' },
                { title: this.$t('table.assetFull.Soba'), key: 'RoomName', sortable: true, width: '14%' },
                { title: this.$t('general.optionsUPPER'), key: 'Actions', sortable: false, width: '16%' },
            ],
        }
    },

    computed: {
        popisId() {
            return this.$route.params.id
        },
        filteredSkenirano() {
            const term = this.searchSkenirano.toLowerCase().trim()
            if (!term) return this.skenirano
            return this.skenirano.filter(a =>
                Object.values(a).some(val => String(val ?? '').toLowerCase().includes(term))
            )
        },
        filteredNijePronasao() {
            const term = this.searchSkenirano.toLowerCase().trim()
            if (!term) return this.nijePronasao
            return this.nijePronasao.filter(a =>
                Object.values(a).some(val => String(val ?? '').toLowerCase().includes(term))
            )
        },
        filteredPreostala() {
            const term = this.searchPreostala.toLowerCase().trim()
            if (!term) return this.preostala
            return this.preostala.filter(a =>
                Object.values(a).some(val => String(val ?? '').toLowerCase().includes(term))
            )
        }
    },

    async mounted() {
        await this.fetchData()
    },

    methods: {
        async returnNotFound(item) {
            try {
                await this.$axios.put('Popis/ReturnChecked/' + item.Id)

                const index = this.nijePronasao.findIndex(p => p.Id === item.Id)
                if (index !== -1) {
                    const [moved] = this.nijePronasao.splice(index, 1)
                    this.preostala.unshift(moved)
                }

                this.$store.dispatch('NOTIF_SUCCESS', {
                    poruka: this.$t('User_message.m157'),
                    position: 'top-end',
                    timer: 2500,
                    action: 'noreload'
                })
            } catch (err) {
                console.error(err)
            }
        },
        async returnChecked(item) {
            try {
                await this.$axios.put('Popis/ReturnChecked/' + item.Id)

                const index = this.skenirano.findIndex(p => p.Id === item.Id)
                if (index !== -1) {
                    const [moved] = this.skenirano.splice(index, 1)
                    this.preostala.unshift(moved)
                }

                this.$store.dispatch('NOTIF_SUCCESS', {
                    poruka: this.$t('User_message.m157'),
                    position: 'top-end',
                    timer: 2500,
                    action: 'noreload'
                })
            } catch (err) {
                console.error(err)
            }
        },
        async fetchData() {
            this.loading = true
            try {
                const data = {
                    PopisId: Number(this.popisId),
                    CompanyId: Number(localStorage.getItem('CompanyId')),
                    LanguageId: Number(localStorage.getItem('LanguageId')),
                }
                const res = await this.$axios.post('Popis/ShowStatusPopisa', data)
                this.skenirano = res.data?.skenirano || []
                this.nijePronasao = res.data?.nijePronadjeno || []
                this.preostala = res.data?.neskenirano || []

                // Fetchuj info o popisu
                const r = await this.$axios.post('Popis/Show', {
                    Id: Number(localStorage.getItem('CompanyId')),
                    LanguageId: Number(localStorage.getItem('LanguageId'))
                })

                this.popisInfo = (r.data || []).find(p =>
                    String(p.Id) === String(this.popisId)
                ) || null

            } catch (err) {
                console.error(err)
                this.skenirano = []
                this.preostala = []
                this.nijePronasao = []
            } finally {
                this.loading = false
            }
        },

        openActionDialog(item, type) {
            this.pendingItem = item
            this.pendingActionType = type
            this.actionNote = type === 'notfound' ? this.$t('modalni.popis.nijePronadjenoKomentar') : ''
            this.actionDialog = true
        },

        closeActionDialog() {
            this.actionDialog = false
            this.pendingItem = null
            this.pendingActionType = null
            this.actionNote = ''
        },

        async confirmAction() {
            if (this.pendingActionType === 'check') {
                await this.checkAsset(this.pendingItem)
            } else {
                await this.markAsNotFound(this.pendingItem)
            }
        },

        async checkAsset(item) {
            this.actionLoading = true
            try {
                await this.$axios.put('Popis/Checked/' + item.Id)

                // Ako ima napomenu — pozovi PopisAction
                if (this.actionNote?.trim()) {
                    await this.$axios.put('Popis/PopisAction', {
                        AssetId: item.AssetId,
                        Note: this.actionNote.trim(),
                        CompanyId: Number(localStorage.getItem('CompanyId')),
                    })
                }

                const index = this.preostala.findIndex(p => p.Id === item.Id)
                if (index !== -1) {
                    const [moved] = this.preostala.splice(index, 1)
                    moved.Find = true
                    this.skenirano.unshift(moved)
                }

                this.closeActionDialog()

                this.$store.dispatch('NOTIF_SUCCESS', {
                    poruka: this.$t('User_message.m129'),
                    position: 'top-end',
                    timer: 2500,
                    action: 'noreload'
                })

                if (this.preostala.length === 0) {
                    await this.$axios.put('Popis/EditStatusPopisa', {
                        PopisId: Number(this.popisId),
                        CompanyId: Number(localStorage.getItem('CompanyId'))
                    })
                    this.$store.dispatch('NOTIF_SUCCESS', {
                        poruka: this.$t('modalni.popis.popisZatvoren'),
                        position: 'center',
                        timer: 3000,
                        action: 'noreload'
                    })
                }

            } catch (err) {
                console.error(err)
                await this.fetchData()
            } finally {
                this.actionLoading = false
            }
        },

        async markAsNotFound(item) {
            this.actionLoading = true
            try {
                await this.$axios.put('Popis/NijePronadjeno/' + item.Id)

                // Ako ima napomenu — pozovi PopisAction
                if (this.actionNote?.trim()) {
                    await this.$axios.put('Popis/PopisAction', {
                        AssetId: item.AssetId,
                        Note: this.actionNote.trim(),
                        CompanyId: Number(localStorage.getItem('CompanyId')),
                    })
                }

                const index = this.preostala.findIndex(p => p.Id === item.Id)
                if (index !== -1) {
                    const [moved] = this.preostala.splice(index, 1)
                    moved.Find = null
                    this.nijePronasao.unshift(moved)
                }

                this.closeActionDialog()

                this.$store.dispatch('NOTIF_SUCCESS', {
                    poruka: this.$t('User_message.m128'),
                    position: 'top-end',
                    timer: 2500,
                    action: 'noreload'
                })

            } catch (err) {
                console.error('markAsNotFound greška:', err)
                console.error('err.response:', err.response)
            } finally {
                this.actionLoading = false
            }
        },

        openStatusNoteDialog(item, statusId) {
            this.pendingItem = item
            this.pendingStatus = statusId
            this.statusChangeNote = ''
            this.statusNoteDialog = true
        },

        async confirmAssetStatusChange() {
            try {
                await this.$axios.put('Asset/StalnaSredstva/EditStatus', {
                    AssetId: this.pendingItem.AssetId,
                    StatusId: this.pendingStatus,
                    CompanyId: Number(localStorage.getItem('CompanyId')),
                    Note: this.statusChangeNote
                })
                this.$store.dispatch('NOTIF_SUCCESS', {
                    poruka: this.$t('User_message.m51'),
                    position: 'top-end',
                    timer: 2500,
                    action: 'noreload'
                })
                this.statusNoteDialog = false
                this.pendingItem = null
                this.pendingStatus = null
                this.statusChangeNote = ''
                await this.fetchData()
            } catch (err) {
                console.error(err)
            }
        },
    }
}
</script>